import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum FocusOn {
  None,
  EditParameters,
  ChangeLogs,
}
export interface ViewState {
  // Set what button to focus on
  focusTarget: FocusOn;
}

export const initialState: ViewState = {
  focusTarget: FocusOn.None,
};

const viewStateSlice = createSlice({
  name: "viewState",
  initialState,
  reducers: {
    setFocusTarget: (state, action: PayloadAction<FocusOn>) => {
      state.focusTarget = action.payload;
    },
    resetViewState: (state) => {
      state.focusTarget = initialState.focusTarget;
    },
    resetFocusTarget: (state) => {
      state.focusTarget = FocusOn.None;
    },
  },
});

export const {
  resetViewState,
  setFocusTarget,
  resetFocusTarget: resetFocusButton,
} = viewStateSlice.actions;

export default viewStateSlice.reducer;
